import { Chip } from "@mui/material";
import { AtTagFolioProps, AtTagFolioStatus } from "../at-tag.types";

export const TagFolio = ({ status }: AtTagFolioProps) => {
  const { color, backgroundColor } = getColor(status) || {};
  const text = getLabel(status) || "";

  return (
    <Chip
      label={text}
      className={`!text-xs !font-medium ${backgroundColor} ${color}`}
    />
  );
};

const getLabel = (status: AtTagFolioStatus) => {
  switch (status) {
    case AtTagFolioStatus.OPEN:
      return "Abierto";
    case AtTagFolioStatus.CLOSED:
      return "Cerrado";
    case AtTagFolioStatus.ACTIVE:
      return "Activo";
  }
};

const getColor = (status: AtTagFolioStatus) => {
  switch (status) {
    case AtTagFolioStatus.OPEN:
      return {
        color: "!text-success-800",
        backgroundColor: "!bg-success-50",
      };
    case AtTagFolioStatus.CLOSED:
      return {
        color: "!text-surface-500",
        backgroundColor: "!bg-surface-50",
      };
    case AtTagFolioStatus.ACTIVE:
      return {
        color: "!text-warning-800",
        backgroundColor: "!bg-warning-50",
      };
  }
};
